"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTabPanels = void 0;
var TabPanelCompact_1 = require("./model/TabPanelCompact");
exports.defaultTabPanels = [
    {
        tabName: "Sales Brochure",
        tabType: TabPanelCompact_1.TabType.SalesBrochures,
        externalLinks: [],
        table: {
            header: [
                "Date of Printing / Revision",
                "Sales Brochure No.",
                ""
            ],
            body: [
                [
                    "24/09/2024",
                    "Sales_Brochure_mount-pokfulam_270324",
                    "/Document/en-US/SalesBrochure/mount-pokfulam/Sales_Brochure_mount-pokfulam_270324.pdf"
                ],
                [
                    "24/09/2024",
                    "Sales_Brochure_mount-pokfulam_270324",
                    "/Document/en-US/SalesBrochure/mount-pokfulam/Sales_Brochure_mount-pokfulam_270324.pdf"
                ]
            ]
        },
    }, {
        tabName: "Floor Plans",
        tabType: 0,
        externalLinks: [],
        table: {
            header: [
                "Date of Printing / Revision",
                "Price List No.",
                ""
            ],
            body: [
                [
                    "24/09/2024",
                    "Register_Of_Transactions_mount-pokfulam",
                    "/Document/en-US/RegisterOfTransaction/mount-pokfulam/Register_Of_Transactions_mount-pokfulam.pdf"
                ]
            ]
        },
    }, {
        tabName: "Price List",
        tabType: TabPanelCompact_1.TabType.PriceList,
        externalLinks: [],
        table: {
            header: [
                "Date of Printing / Revision",
                "Floor Plan No.",
                ""
            ],
            body: [
                [
                    "24/09/2024",
                    "Sales_Brochure_mount-pokfulam_270324",
                    "/Document/en-US/SalesBrochure/mount-pokfulam/Sales_Brochure_mount-pokfulam_270324.pdf"
                ],
                [
                    "24/09/2024",
                    "Sales_Brochure_mount-pokfulam_270324",
                    "/Document/en-US/SalesBrochure/mount-pokfulam/Sales_Brochure_mount-pokfulam_270324.pdf"
                ]
            ]
        },
    },
    {
        tabName: "Sales Arrangement",
        tabType: TabPanelCompact_1.TabType.SalesArrangement,
        externalLinks: [],
        table: {
            header: [
                "Date of Revision",
                "Sales Arrangement",
                ""
            ],
            body: [
                [
                    "24/09/2024",
                    "Sales_Arrangement_mount-pokfulam",
                    "/Document/en-US/SalesArrangement/mount-pokfulam/Sales_Arrangement_mount-pokfulam.pdf"
                ]
            ]
        },
    },
    {
        tabName: "Register Of Transactions",
        tabType: TabPanelCompact_1.TabType.RegisterOfTransactions,
        externalLinks: [],
        table: {
            header: [
                "Date of Revision",
                "Register Of Transactions",
                ""
            ],
            body: [
                [
                    "24/09/2024",
                    "Register_Of_Transactions_mount-pokfulam",
                    "/Document/en-US/RegisterOfTransaction/mount-pokfulam/Register_Of_Transactions_mount-pokfulam.pdf"
                ]
            ]
        },
    }
];
